import { CircleQuestionMark } from "lucide-react";

import { FormLabel } from "./form";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

type RequiredLabelProps = {
  children: React.ReactNode;
  required?: boolean;
  htmlFor?: string;
  tooltip?: string;
};

export function RequiredLabel({
  children,
  required,
  tooltip,
  htmlFor,
}: RequiredLabelProps) {
  return (
    <FormLabel htmlFor={htmlFor}>
      <span className="inline-flex items-center gap-1">
        {children}
        {required && <span className="text-red-500">*</span>}
        {tooltip && (
          <span>
            <Popover>
              <PopoverTrigger>
                <span tabIndex={0}>
                  <CircleQuestionMark className="w-4 h-4 cursor-pointer" />
                </span>
              </PopoverTrigger>
              <PopoverContent
                side="top"
                align="start"
                className="max-w-xs text-sm bg-gray-100/80"
              >
                {tooltip}
              </PopoverContent>
            </Popover>
          </span>
        )}
      </span>
    </FormLabel>
  );
}
